'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getTrialState from 'self-service-api/api/getTrialState';
import { TEMPORARY_REMOTE_TOOLS } from 'self-service-api/constants/UpgradeProducts';
import { sourceKeys } from '../../common/data/upgradeData/properties/sources';
import ActivationErrorModal from '../../common/components/activation/ActivationErrorModal';
import ActivationSuccessModal from '../../common/components/activation/ActivationSuccessModal';
import { upgradeDataPropsInterface } from '../../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
var MODAL_STATES = {
  LOADING: 'LOADING',
  SHOW_SUCCESS_MODAL: 'SHOW_SUCCESS_MODAL',
  SHOW_ERROR_MODAL: 'SHOW_ERROR_MODAL'
};

var RemoteToolsActivationErrorModal = function RemoteToolsActivationErrorModal(_ref) {
  var error = _ref.error,
      onSuccess = _ref.onSuccess,
      upgradeData = _ref.upgradeData;
  var shouldCheckTrialState = error.status === 400 && error.responseText.includes('overlapping');

  var _useState = useState(shouldCheckTrialState ? MODAL_STATES.LOADING : MODAL_STATES.SHOW_ERROR_MODAL),
      _useState2 = _slicedToArray(_useState, 2),
      modalState = _useState2[0],
      setModalState = _useState2[1];

  useEffect(function () {
    if (shouldCheckTrialState) {
      getTrialState().then(function (trialState) {
        var inTrial = trialState && trialState[TEMPORARY_REMOTE_TOOLS] && trialState[TEMPORARY_REMOTE_TOOLS].inTrial;

        if (inTrial) {
          setModalState(MODAL_STATES.SHOW_SUCCESS_MODAL);
        } else {
          setModalState(MODAL_STATES.SHOW_ERROR_MODAL);
        }
      }).catch(function () {
        setModalState(MODAL_STATES.SHOW_ERROR_MODAL);
      }).done();
    }

    return undefined;
  }, [shouldCheckTrialState]);

  switch (modalState) {
    case MODAL_STATES.LOADING:
      return null;

    case MODAL_STATES.SHOW_ERROR_MODAL:
    default:
      return React.createElement(ActivationErrorModal, null);

    case MODAL_STATES.SHOW_SUCCESS_MODAL:
      return React.createElement(ActivationSuccessModal, {
        type: sourceKeys.TRIAL,
        onSuccess: onSuccess,
        header: React.createElement(FormattedMessage, {
          message: "upgrades.activationModal.remoteToolsActivationModal.header"
        }),
        subText: React.createElement(FormattedMessage, {
          message: "upgrades.activationModal.remoteToolsActivationModal.body"
        }),
        ctaText: React.createElement(FormattedMessage, {
          message: "upgrades.activationModal.remoteToolsActivationModal.header"
        }),
        showIllustration: false,
        upgradeData: upgradeData
      });
  }
};

RemoteToolsActivationErrorModal.propTypes = Object.assign({
  error: PropTypes.object.isRequired,
  onSuccess: PropTypes.func
}, upgradeDataPropsInterface);
export default RemoteToolsActivationErrorModal;